function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var Accordion = /*#__PURE__*/function (_HTMLElement) {
  function Accordion() {
    var _this;
    _classCallCheck(this, Accordion);
    _this = _callSuper(this, Accordion);
    _this.init();
    return _this;
  }
  _inherits(Accordion, _HTMLElement);
  return _createClass(Accordion, [{
    key: "init",
    value: function init() {
      this.initClickEvent();
      this.activeFirstItem();
    }
  }, {
    key: "initClickEvent",
    value: function initClickEvent() {
      var _this2 = this;
      var accordionList = this.querySelector('.accordion-js-list');
      if (!accordionList) {
        return;
      }
      accordionList.addEventListener('click', function (event) {
        var target = event.target;
        if (target.classList.contains('accordion-js-title')) {
          var parent = target.closest('.accordion-js-item');
          var content = parent === null || parent === void 0 ? void 0 : parent.querySelector('.accordion-js-content');
          content.classList.contains('active') ? _this2.close(target, content) : _this2.open(target, content);
        }
      });
    }
  }, {
    key: "activeFirstItem",
    value: function activeFirstItem() {
      if (this.dataset.openFirstItem !== 'true') {
        return;
      }
      var buttons = this.querySelectorAll('.accordion-js-title');
      var dropdowns = this.querySelectorAll('.accordion-js-content');
      var buttonActive = buttons[0];
      var dropDownActive = dropdowns[0];
      this.open(buttonActive, dropDownActive);
    }
  }, {
    key: "open",
    value: function open(button, dropDown) {
      this.closeAllDrops(button, dropDown);
      dropDown.style.height = dropDown.scrollHeight + 'px';
      button.classList.add('active');
      dropDown.classList.add('active');
    }
  }, {
    key: "close",
    value: function close(button, dropDown) {
      button.classList.remove('active');
      dropDown.classList.remove('active');
      dropDown.style.height = '';
    }
  }, {
    key: "closeAllDrops",
    value: function closeAllDrops(button, dropDown) {
      var _this3 = this;
      var accordionListItems = this.querySelectorAll('.accordion-js-item');
      accordionListItems.forEach(function (elem) {
        var btn = elem.children[0];
        var drop = elem.children[1];
        if (btn !== button && drop !== dropDown) {
          _this3.close(btn, drop);
        }
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
export default Accordion;